import { Dialog, DialogContent } from "@mui/material";
import * as coreApi from "api/Core";
import { SpinnerIndicator } from "components/CallServer";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiDialogTitleClose from "components/MuiExtras/MuiDialogTitleClose";
import * as QRCode from "qrcode.react";
import * as React from "react";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { QrCodeDto } from "models/ApiModels";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    qrCode: QrCodeDto;
    lastError: any;
}

interface IProps {
    onClose: () => void;

}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////

export class UserMobileQrCode extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { qrCode: null, lastError: null };
    }

    ///
    private res(r: string) {
        return this.props.t("Views.User.Dialogs.UserMobileQrCode." + r);
    }

    ///
    private onLoad() {
        coreApi.getQrCodeToken()
            .then((qrCode) => {
                this.setState({ qrCode });
            })
            .catch((error: any) => {
                this.setState({ lastError: error.message || error });
            });
    }

    ///
    public componentDidMount() {
        this.onLoad();
    }

    ///
    public render() {
        const { qrCode } = this.state;
        const location = window.location;
        const baseUrl = location.protocol + "//" + location.host;
        return (
            <Dialog open onClose={() => this.props.onClose()}>
                <MuiDialogTitleClose
                    onClose={this.props.onClose}
                >
                    <span>{this.res("BoxTitle")}</span>
                </MuiDialogTitleClose>
                <DialogContent>
                    {
                        this.state.lastError
                            ? <MuiMessageBox variant="error" message={this.state.lastError} />
                            : (
                                <>
                                    <div style={{ textAlign: "center" }}>
                                        {
                                            qrCode == null
                                                ? <SpinnerIndicator />
                                                : <>
                                                    <QRCode value={`apiUrl=${baseUrl}&token=${qrCode.qrCodeToken}`} size={384} />
                                                    <div>
                                                        {`${qrCode.qrAlternateAccessCode.substr(0, 4)}-${qrCode.qrAlternateAccessCode.substr(4, 4)}-${qrCode.qrAlternateAccessCode.substr(8, 4)}`}
                                                    </div>
                                                </>

                                        }
                                    </div>
                                    <ul>
                                        <li>{this.res("L1")}</li>
                                        <li><Trans i18nKey="Views.User.Dialogs.UserMobileQrCode.L2" components={[<b></b>]} /></li>
                                        <li>{this.res("L3")}</li>
                                        <li>{this.res("L4")}</li>
                                    </ul>
                                </>
                            )
                    }
                </DialogContent>
            </Dialog>
        );
    }
}

export default withTranslation()(UserMobileQrCode);
